import React, { useEffect, useState } from "react";
import CustomButton from "../CustomButton";
import DesignCard from "../DesignCard";
import {
  Row,
  Col,
  Form,
  Label,
  FormGroup,
  Card,
  CardBody,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import Icon from "react-icons-kit";
import { ic_check } from "react-icons-kit/md/ic_check";
import { ic_close } from "react-icons-kit/md/ic_close";
import {
  approveRejectUpdatedTourDetails,
  deleteUpdatedTourDetails,
  fetchUpdatedToursData,
} from "../../redux/moderation/tours/actions";
import { useDispatch, useSelector } from "react-redux";
import {
  approveRejectUpdatedExperienceDetails,
  deleteUpdatedExperienceDetails,
  fetchUpdatedExperienceData,
} from "../../redux/moderation/experience/actions";
import config from "../../utils/config";
import get from "lodash/get";
import InputText from "../InputText";
import {
  approveRejectUpdatedTestimonialDetails,
  deleteUpdatedTestimonialDetails,
  fetchUpdatedTestimonailData,
} from "../../redux/Testimonials/action";

const _ = { get };

const UpdateModerationModal = (props) => {
  const { usertype } = useSelector((state) => state.Auth);
  const dispatch = useDispatch();
  const [activeCollapse, setActiveCollapse] = useState(false);
  const { elements } = useSelector((state) => state.Elements);
  const ToggleCollapse = () => {
    setActiveCollapse(!activeCollapse);
  };
  const [key, setKey] = useState("");
  const [rejectionReason, setRejectionReason] = useState("");
  const [indexId, setIndexId] = useState("");
  const [rejectionReasonImage, setRejectionReasonImage] = useState("");
  const [rejectionReasonToggle, setRejectionReasonToggle] = useState(false);

  const { fetchingUpdatedDetails, updatedDetails } = useSelector((state) =>
    props.category === "Tour"
      ? state.Tours
      : props.category === "Experience"
      ? state.Experience
      : state.Testimonials
  );

  const FieldName = [
    {
      name: "name",
      value: "Name",
    },
    {
      name: "startPoint",
      value: "Start Location",
    },
    {
      name: "endPoint",
      value: "End Location",
    },
    {
      name: "startDate",
      value: "Start Date",
    },
    {
      name: "endDate",
      value: "End Date",
    },
    {
      name: "region",
      value: "Region",
    },
    {
      name: "description",
      value: "Description",
    },
    {
      name: "redirectionUrl",
      value: "Redirection Url",
    },
    {
      name: "country",
      value: "Country",
    },
    {
      name: "totalDistance",
      value: "Estimated Distance Covered (KM)",
    },
    {
      name: "thumbnailImage",
      value: "Thumbnail - Tour Landing - Common - (160 x 190 px)",
    },
    {
      name: "thumbnailPartnerImage",
      value:
        "Thumbnail - Partner Detail - Tour Listing - Common - (360 x 310 px)",
    },
    {
      name: "gallery",
      value: "Gallery Common",
    },
  ];

  const FieldName2 = [
    {
      name: "author",
      value: "Rider Name",
    },
    {
      name: "location",
      value: "Rider Location",
    },
    {
      name: "postedDate",
      value: "Posted Date",
    },
    {
      name: "description",
      value: "Rider Note",
    },
    {
      name: "image",
      value: "Rider Image/Default image",
    },
  ];

  const fields = (value) => {
    if (props.category !== "Testimonial") {
      const data = FieldName.map((item) => {
        if (item.name === value) {
          return item.value;
        }
      });
      return data;
    } else {
      const data = FieldName2.map((item) => {
        if (item.name === value) {
          return item.value;
        }
      });
      return data;
    }
  };

  const handleReject = () => {
    setRejectionReasonToggle(!rejectionReasonToggle);
    handleAcceptorRejectImage("REJECTED");
  };

  const rejectionOnSubmit = () => {
    let data = {
      wanderlustId: props.wanderlustId,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      key: key,
      category: props.category.toUpperCase(),
    };
    let data2 = {
      testimonialId: props.wanderlustId,
      status: "REJECTED",
      rejectionReason: rejectionReason,
      key: key,
    };
    if (props.category === "Tour") {
      dispatch(approveRejectUpdatedTourDetails(data, ToggleCollapse));
    } else if (props.category === "Experience") {
      dispatch(approveRejectUpdatedExperienceDetails(data, ToggleCollapse));
    } else {
      dispatch(approveRejectUpdatedTestimonialDetails(data2, ToggleCollapse));
    }
  };

  const approveOnClick = (keys) => {
    let data = {
      wanderlustId: props.wanderlustId,
      status: "APPROVED",
      key: keys,
      category: props.category.toUpperCase(),
    };
    let data2 = {
      testimonialId: props.wanderlustId,
      status: "APPROVED",
      key: keys,
    };
    if (props.category === "Tour") {
      dispatch(
        approveRejectUpdatedTourDetails(data, props.handleBackCallOnSubmit)
      );
    } else if (props.category === "Experience") {
      dispatch(
        approveRejectUpdatedExperienceDetails(
          data,
          props.handleBackCallOnSubmit
        )
      );
    } else {
      dispatch(
        approveRejectUpdatedTestimonialDetails(
          data2,
          props.handleBackCallOnSubmit
        )
      );
    }
  };

  const handleAcceptorRejectImage = (status) => {
    let data = {
      wanderlustId: props.wanderlustId,
      status: status,
      key: "gallery",
      category: props.category.toUpperCase(),
      rejectionReason: rejectionReasonImage !== "" ? rejectionReasonImage : "",
    };
    let data2 = {
      testimonialId: props.wanderlustId,
      status: status,
      key: "image",
      rejectionReason: rejectionReasonImage !== "" ? rejectionReasonImage : "",
    };
    if (props.category === "Tour") {
      dispatch(
        approveRejectUpdatedTourDetails(data, props.handleBackCallOnSubmit)
      );
    } else if (props.category === "Experience") {
      dispatch(
        approveRejectUpdatedExperienceDetails(
          data,
          props.handleBackCallOnSubmit
        )
      );
    } else {
      dispatch(
        approveRejectUpdatedTestimonialDetails(
          data2,
          props.handleBackCallOnSubmit
        )
      );
    }
  };

  const handleDeleteField = (keys) => {
    let data = {
      wanderlustId: props.wanderlustId,
      key: keys,
    };
    let data2 = {
      testimonialId: props.wanderlustId,
      key: keys,
    };
    if (props.category === "Tour") {
      dispatch(deleteUpdatedTourDetails(data, props.handleBackCall));
    } else if (props.category === "Experience") {
      dispatch(deleteUpdatedExperienceDetails(data, props.handleBackCall));
    } else {
      dispatch(deleteUpdatedTestimonialDetails(data2, props.handleBackCall));
    }
  };

  useEffect(() => {
    if (props.category === "Tour") {
      dispatch(fetchUpdatedToursData(props.wanderlustId));
    } else if (props.category === "Experience") {
      dispatch(fetchUpdatedExperienceData(props.wanderlustId));
    } else {
      dispatch(fetchUpdatedTestimonailData(props.wanderlustId));
    }
  }, []);

  useEffect(() => {
    if (
      updatedDetails &&
      updatedDetails.changes &&
      updatedDetails.changes.length === 0 &&
      updatedDetails.changesGallery &&
      Object.keys(updatedDetails.changesGallery).length === 0
    ) {
      ToggleCollapse();
    } else if (
      updatedDetails &&
      updatedDetails.changes &&
      updatedDetails.changes.length === 0 &&
      updatedDetails.image &&
      Object.keys(updatedDetails.image).length === 0
    ) {
      ToggleCollapse();
    }
  }, [updatedDetails]);

  return (
    <div>
      <div class="col-md-12 d-flex justify-content-between align-items-center">
        <h2 class="title-bar secondary-title font-weight-bold themeColor">
          <span>
            {props.category === "Tour"
              ? "Tour Detail"
              : props.category === "Experience"
              ? "Experience Details"
              : "Testimonial Details"}
          </span>
        </h2>
        <p className="statusTxt">Status</p>
      </div>
      {updatedDetails &&
        updatedDetails.changes &&
        updatedDetails.changes[0] !== null &&
        updatedDetails.changes.map((item) => (
          <Col md={12} className="my-3">
            <div className="d-flex flex-wrap align-items-center justify-content-between">
              <DesignCard
                name={fields(item.field)}
                titleName={
                  item.field === "endPoint" || item.field === "startPoint"
                    ? item.value.name
                    : item.value
                }
              />
              {usertype &&
              (usertype === "EU Tours Admin" || usertype === "Admin") ? (
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn close_btn"
                    onClick={() => {
                      ToggleCollapse();
                      setKey(item.field);
                      setIndexId(item._id);
                    }}
                  >
                    <Icon size={20} icon={ic_close} />
                  </button>
                  <button type="button" className="btn check_btn ml-2">
                    <Icon
                      size={20}
                      icon={ic_check}
                      onClick={() => {
                        approveOnClick(item.field);
                        setKey(item.field);
                      }}
                    />
                  </button>
                </div>
              ) : (
                <p className={`statusTag ${item.approved.toLowerCase()}`}>
                  {item.approved}
                </p>
              )}
            </div>
            {item.rejectionReason && item.rejectionReason !== "" && (
              <div className="d-flex justify-content-between mt-2">
                <div>
                  <Label className="rejection">Reason of Rejection</Label>
                  <p>{item.rejectionReason}</p>
                </div>
                {usertype && usertype === "EU Tours Partner" && (
                  <CustomButton
                    customType={"button"}
                    name="Delete"
                    customClass={
                      "btn-outline-dark bg-none btnthemeColor partner_p_button"
                    }
                    customClick={() => handleDeleteField(item.field)}
                  />
                )}
              </div>
            )}
            <div
              className={`${
                activeCollapse && indexId == item._id ? "show" : ""
              } collapse`}
            >
              <Label className="inputLabel">Reason of Rejection</Label>
              <div>
                <FormGroup className="inputWrpper customInputBox">
                  <textarea
                    name="reason"
                    placeholder="Type reason here..."
                    className="inputText mb-0 form-control"
                    rows="4"
                    maxLength={80}
                    onChange={(e) => setRejectionReason(e.target.value)}
                  ></textarea>
                </FormGroup>
                <div className="d-flex align-items-center justify-content-between">
                  <CustomButton
                    customType={"button"}
                    name="Cancel"
                    customClass={"btn-outline-dark bg-none btnthemeColor"}
                    customClick={() => ToggleCollapse()}
                  />
                  <CustomButton
                    customType={"button"}
                    name="Submit"
                    customClass={"btn-outline-dark bg-none btnthemeColor ml-3"}
                    customClick={() => rejectionOnSubmit()}
                  />
                </div>
              </div>
            </div>
          </Col>
        ))}
      {updatedDetails &&
        updatedDetails.changesGallery &&
        Object.keys(updatedDetails.changesGallery).length > 1 && (
          <div className="col-md-12 d-flex justify-content-between align-items-center my-3">
            <h2 className="title-bar secondary-title font-weight-bold themeColor">
              <span>Media</span>
            </h2>
            {usertype === "EU Tours Partner" && (
              <p
                className={`statusTag ${updatedDetails &&
                  updatedDetails.galleryApproved &&
                  updatedDetails.galleryApproved.toLowerCase()}`}
              >
                {updatedDetails.galleryApproved}
              </p>
            )}
          </div>
        )}
      {updatedDetails &&
        updatedDetails.changesGallery &&
        Object.keys(updatedDetails.changesGallery).length > 1 &&
        Object.keys(updatedDetails.changesGallery).map((item) => (
          <Col md={12}>
            <div class="personal_tour_image">{fields(item)}</div>
            <Row>
              {updatedDetails &&
                updatedDetails.changesGallery &&
                updatedDetails.changesGallery[item] &&
                updatedDetails.changesGallery[item].images &&
                updatedDetails.changesGallery[item].images.map((data) => (
                  <Col md={3}>
                    <img
                      class="image_tour2"
                      src={`${config.imageBaseUrl}/${data.srcPath}`}
                      alt="img"
                    />
                  </Col>
                ))}
            </Row>
          </Col>
        ))}
      {updatedDetails &&
        updatedDetails.galleryrejectionReason &&
        updatedDetails.changesGallery &&
        Object.keys(updatedDetails.changesGallery).length > 0 && (
          <div className="d-flex justify-content-between px-2 mt-2">
            <div>
              <Label className="rejection">Reason of Rejection</Label>
              <p>{updatedDetails && updatedDetails.galleryrejectionReason}</p>
            </div>
            {usertype && usertype === "EU Tours Partner" && (
              <CustomButton
                customType={"button"}
                name="Delete"
                customClass={
                  "btn-outline-dark bg-none btnthemeColor partner_p_button"
                }
                customClick={() => handleDeleteField("gallery")}
              />
            )}
          </div>
        )}
      {props.category === "Testimonial" &&
        updatedDetails &&
        updatedDetails.image &&
        updatedDetails.image.images && (
          <Col md={12}>
            <div className=" d-flex justify-content-between align-items-center my-3">
              <div class="personal_tour_image">{fields("image")}</div>
              {usertype && usertype === "EU Tours Partner" && (
                <p
                  className={`statusTag ${updatedDetails &&
                    updatedDetails.galleryApproved &&
                    updatedDetails.galleryApproved.toLowerCase()}`}
                >
                  {updatedDetails && updatedDetails.galleryApproved}
                </p>
              )}
            </div>
            <Row>
              {updatedDetails &&
                updatedDetails.image &&
                updatedDetails.image.images &&
                updatedDetails.image.images.map((data) => (
                  <Col md={3}>
                    <img
                      class="image_tour2"
                      src={`${config.imageBaseUrl}/${data.srcPath}`}
                      alt="img"
                    />
                  </Col>
                ))}
            </Row>
          </Col>
        )}
      {props.category === "Testimonial" &&
        updatedDetails &&
        updatedDetails.galleryrejectionReason && (
          <div className="d-flex justify-content-between px-2 mt-2">
            <div>
              <Label className="rejection">Reason of Rejection</Label>
              <p>{updatedDetails && updatedDetails.galleryrejectionReason}</p>
            </div>
            {usertype && usertype === "EU Tours Partner" && (
              <CustomButton
                customType={"button"}
                name="Delete"
                customClass={
                  "btn-outline-dark bg-none btnthemeColor partner_p_button"
                }
                customClick={() => handleDeleteField("gallery")}
              />
            )}
          </div>
        )}
      {props.category === "Testimonial" &&
        updatedDetails &&
        updatedDetails.image &&
        updatedDetails.image.images &&
        usertype &&
        (usertype === "EU Tours Admin" || usertype === "Admin") && (
          <Col md={12} className="d-flex justify-content-between mt-3">
            <CustomButton
              customType={"button"}
              name="Reject All"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() =>
                setRejectionReasonToggle(!rejectionReasonToggle)
              }
            />
            <CustomButton
              customType={"button"}
              name="Accept All"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() => handleAcceptorRejectImage("APPROVED")}
            />
          </Col>
        )}
      {updatedDetails &&
        updatedDetails.changesGallery &&
        Object.keys(updatedDetails.changesGallery).length > 1 &&
        usertype &&
        (usertype === "EU Tours Admin" || usertype === "Admin") && (
          <Col md={12} className="d-flex justify-content-between mt-3">
            <CustomButton
              customType={"button"}
              name="Reject All"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() =>
                setRejectionReasonToggle(!rejectionReasonToggle)
              }
            />
            <CustomButton
              customType={"button"}
              name="Accept All"
              customClass={"btn-outline-dark bg-none btnthemeColor"}
              customClick={() => handleAcceptorRejectImage("APPROVED")}
            />
          </Col>
        )}
      <Modal isOpen={rejectionReasonToggle} backdrop={true} centered={true}>
        <ModalHeader
          toggle={() => {
            setRejectionReasonToggle(!rejectionReasonToggle);
            setRejectionReason("");
          }}
        >
          {_.get(
            elements,
            "euToursElement.partnerPersonalInfoElement.rejectionModelLabel",
            "Rejection Reason"
          )}
        </ModalHeader>
        <ModalBody>
          <InputText
            inputType={"textarea"}
            inputName={"rejectionReason"}
            customValue={rejectionReasonImage}
            customOnChange={(e) => setRejectionReasonImage(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <CustomButton
            customType={"submit"}
            name={_.get(
              elements,
              "euToursElement.partnerPersonalInfoElement.rejectElement",
              "Reject"
            )}
            customClass={"btn-outline-dark bg-none ml-2 btnthemeColor"}
            customClick={() => handleReject()}
          />
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default UpdateModerationModal;
